import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';
import {WeaAuth} from 'ecCom';

import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

@inject('coworkStoreMap')
@observer
export default class NewAuth extends React.Component {
  componentDidMount() {
    const coworkNewStore = this.props.coworkStoreMap.getMapStore(this.props.storeMapKey);
    coworkNewStore.getWeaAuthConditions();
  }
  render() {
    const coworkNewStore = this.props.coworkStoreMap.getMapStore(this.props.storeMapKey);
    const {showAuth, authCondition, editId,selectValue} = toJS(coworkNewStore.newCoworkStatus);
    return (
      <WeaAuth
        icon='icon-coms-meeting'
        iconBgcolor='#F14A2D'
        title={getLabel(385978,'添加参与者范围')}
        visible={showAuth}
        conditions={authCondition}
        onOk={datas => {
          coworkNewStore.saveorupdateCoworkShare({id: editId,typeId: selectValue, ...datas})
        }}
        onCancel={() => {
          coworkNewStore.setCreateState({showAuth: false})
        }}
      >
      </WeaAuth>
    )
  }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cowork/components/cowork/dialog/NewAuth.js